module.exports = __webpack_public_path__ + "img/Informatica II.b4e17a09.png";